import PropTypes from 'prop-types';
// material
import { Box, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// ----------------------------------------------------------------------

Logo.propTypes = {
  sx: PropTypes.object
};

export default function Logo({ sx }) {
  const {t} = useTranslation();

  return <RouterLink  className='logo' to="/">
    
    {/* <div className="logo"></div> */}
    <Box sx={{ flexGrow: 1 }} >

      <Typography variant="h1">{t("title")}</Typography>
    </Box> 
  </RouterLink>; // <Box component="img" src="/static/logo.svg" sx={{ width: 40, height: 40, ...sx }} />;
}




{/* */}